import { Component, OnInit } from '@angular/core';
import { ValueService } from 'src/app/services/value.service';

@Component({
  selector: 'app-policy-page',
  templateUrl: './policy-page.component.html',
  styleUrls: ['./policy-page.component.css']
})
export class PolicyPageComponent implements OnInit {
  panelOpenState = true;
  constructor(private getdata:ValueService) { }

  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
  }

}
